module.exports = __webpack_public_path__ + "static/media/arrowPrev.3d8bad0a.svg";